import { SvgIcon } from "@mui/material";

export default function ExpertPanelQuote(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M3.5,21 L8,21 L11,13.8 L11,3 L2,3 L2,13.8 L6.5,13.8 L3.5,21 Z M14.5,21 L19,21 L22,13.8 L22,3 L13,3 L13,13.8 L17.5,13.8 L14.5,21 Z"
        transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
      />
    </SvgIcon>
  );
}
